import React, { useEffect, useState } from "react";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import {
  Row, Col, UncontrolledDropdown, DropdownToggle,
  DropdownMenu, DropdownItem, UncontrolledCollapse, Badge
} from "reactstrap";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";
import CustomSelect from "../../../../Components/Common/CustomSelect";
import { camelCaseToWords } from "../../../../slices/helper.js";
import { setUserPermission } from "../../../../slices/auth/settings/reducer";

/**
 * Functional component for managing permissions.
 * @component
 */
export default function Permission() {
  const dispatch = useDispatch();

  const selectState = createSelector(state => state, state => ({
    menuData: state.MenuData.client,
    permissionList: state.Permission.permissionTypes,
    userPermission: state.Settings.userPermission,
    userModalData: state.Modal.userModalData,
    user: state.Login.user
  }));
  const { menuData, permissionList, userPermission, userModalData, user } = useSelector(selectState);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedPermissionType, setSelectedPermissionType] = useState(null);

  /** Adds a new permission to the list of permissions. */
  function addPermission() {
    if (selectedCampaign !== null && selectedPermissionType !== null) {
      let foundPermission;
      if (userPermission) {
        foundPermission = userPermission.find(item => item.relationId === selectedCampaign.relationId && item.permissionId === selectedPermissionType.permissionId);
        dispatch(setUserPermission([...userPermission, { ...selectedCampaign, ...selectedPermissionType }]))
      } else {
        dispatch(setUserPermission([{ ...selectedCampaign, ...selectedPermissionType }]))
      }
      if (foundPermission) {
        return;
      }

    }
  }; // eslint-disable-line

  /**  Removes a specific permission from the list of permissions.
  * @param {string} removePermission - The permission to be removed. */
  function removePermission(permissionIdx) {
    dispatch(setUserPermission(userPermission.filter((item, idx) => idx !== permissionIdx)));
  }
  return (
    <Row>
      {user?.data.userId !== userModalData?._id ?
        <React.Fragment>
          <Col md="5" sm="6" xs="12">
            <UncontrolledDropdown>
              <DropdownToggle tag="button" type="button" className="form-select d-flex align-items-center user-select-none">
                {(selectedCampaign !== null ? selectedCampaign?.name : <span className="text-muted">Select Campaign</span>)}
              </DropdownToggle>
              <DropdownMenu className="w-100 permission-menu">
                <SimpleBar style={{ width: "100%", maxHeight: "220px" }} className="w-100 d-flex px-2">
                  <li className="nav-item mt-1 mb-1">
                    <Link className="dropdown-item rounded d-flex justify-content-start align-items-center">
                      <div className="form-nested-select" id={menuData.clientName.toLowerCase().split(" ").join("")} data-bs-toggle="collapse">
                      </div>
                      <DropdownItem
                        className="d-flex px-0"
                        onClick={() => {
                          setSelectedCampaign({
                            name: menuData.clientName,
                            level: 3,
                            relationId: menuData._id
                          })
                        }}
                      >{menuData.clientName}</DropdownItem>
                    </Link>
                    <UncontrolledCollapse className="nav-item ps-4 mt-1" toggler={menuData.clientName.toLowerCase().split(" ").join("")}>
                      <ul className="nav nav-sm flex-column gap-1">
                        {(menuData.clients || []).map((client, idx) => {
                          return (
                            <li className="nav-item mt-1 mb-1" key={idx}>
                              <Link
                                className="dropdown-item rounded d-flex justify-content-start align-items-center"
                              >
                                <div
                                  className="form-nested-select"
                                  id={client.clientName.toLowerCase().split(" ").join("")}
                                  data-bs-toggle="collapse"
                                ></div>
                                <DropdownItem
                                  className="d-flex px-0"
                                  onClick={() => {
                                    setSelectedCampaign({
                                      name: menuData.clientName + " - " + client.clientName,
                                      level: 2,
                                      relationId: client._id
                                    })
                                  }}
                                >{client.clientName}</DropdownItem>
                              </Link>
                              <UncontrolledCollapse
                                className="nav-item ps-4 mt-1"
                                toggler={client.clientName.toLowerCase().split(" ").join("")}
                              >
                                <ul className="nav nav-sm flex-column gap-1">
                                  {(client.brands || []).map((brand, idx) => {
                                    return (
                                      <li className="nav-item" key={idx} >
                                        <Link
                                          className="dropdown-item rounded d-flex justify-content-start align-items-center"
                                        >
                                          <div
                                            data-bs-toggle="collapse"
                                            className="form-nested-select"
                                            id={brand.name.toLowerCase().split(" ").join("")}
                                          ></div>
                                          <DropdownItem
                                            className="d-flex px-0"
                                            onClick={() => {
                                              setSelectedCampaign({
                                                name: menuData.clientName + " - " + client.clientName + " - " + brand.name,
                                                level: 1,
                                                relationId: brand._id
                                              })
                                            }}
                                          >{brand.name}</DropdownItem>
                                        </Link>
                                        <UncontrolledCollapse
                                          className="nav-item ps-4 mt-1"
                                          toggler={brand.name.toLowerCase().split(" ").join("")}
                                        >
                                          <ul className="nav nav-sm flex-column gap-1">
                                            {Array.isArray(brand.markets) ? (brand.markets || []).map((market, idx) => {
                                              return (
                                                <li className="nav-item" key={idx}>
                                                  <Link
                                                    className="dropdown-item rounded d-flex justify-content-start align-items-center"
                                                  >
                                                    <DropdownItem
                                                      className="d-flex px-0"
                                                      onClick={() => {
                                                        setSelectedCampaign({
                                                          name: menuData.clientName + " - " + client.clientName + " - " + brand.name + " - " + market.name,
                                                          level: 0,
                                                          relationId: market._id,
                                                        })
                                                      }}
                                                    >{market.name}</DropdownItem>
                                                  </Link>
                                                </li>
                                              )
                                            }) : (
                                              <li className="nav-item" key={idx}>
                                                <Link
                                                  className="dropdown-item rounded d-flex justify-content-start align-items-center"
                                                >
                                                  <DropdownItem
                                                    className="d-flex px-0"
                                                    onClick={() => {
                                                      setSelectedCampaign({
                                                        name: menuData.clientName + " - " + client.clientName + "-" + brand.name + "-" + brand.markets.name,
                                                        level: 0,
                                                        relationId: brand.markets._id
                                                      })
                                                    }}
                                                  >{brand.markets.name}</DropdownItem>
                                                </Link>
                                              </li>
                                            )}
                                          </ul>
                                        </UncontrolledCollapse>
                                      </li>
                                    )
                                  })}
                                </ul>
                              </UncontrolledCollapse>
                            </li>
                          )
                        })}
                      </ul>
                    </UncontrolledCollapse>
                  </li>
                </SimpleBar>
              </DropdownMenu>
            </UncontrolledDropdown >
          </Col>
          <Col md="5" sm="6" xs="12">
            <CustomSelect
              placeholder='Select Permission Type'
              onChange={(item) => setSelectedPermissionType({ permissionId: item.value, permissionName: item.name })}
              options={permissionList.map(item => { return { value: item._id, name: camelCaseToWords(item.name) } })}
            />
          </Col>
          <Col md="2" sm="12" xs="12">
            <button type="button" className="btn btn-primary w-100 mt-xs-3" onClick={addPermission}>Add</button>
          </Col>
        </React.Fragment>
        : null}
      {userPermission && userPermission.length > 0 ?
        <Col xxl="12" xl="12" lg="12" md="12" sm="12" xs="12">
          <div className="w-100 mt-3 d-flex flex-wrap gap-1">
            {(userPermission || []).map((item, idx) => {
              if (user?.data.userId !== userModalData?._id) {
                return (
                  <Badge color="primary" key={idx} className="pe-0 py-0">
                    {item.name} | {item.permissionName}
                    <button type="button" className="btn btn-sm btn-primary ms-1" aria-label="remove" onClick={() => removePermission(idx)}>
                      <i className="ri ri-close-line align-bottom"></i>
                    </button>
                  </Badge>
                )
              } else {
                return (
                  <Badge color="primary" key={idx} className="py-2">
                    {item.name} | {item.permissionName}
                  </Badge>
                )
              }
            })}
          </div>
        </Col>
        : null}
    </Row >
  )
}